<template>
  <div class="empty-state-wrapper">
    <span>Aucune donnée disponible</span>
  </div>
</template>
<script>
export default {};
</script>
<style lang="stylus" scoped>
.empty-state-wrapper {
  display: flex;
  align-items: center;
  flex-direction: center;
  width: 100%;
  margin: 20px auto;
  border: 1px solid #d7dded;
  border-radius: 6px;
  padding: 16px 32px 16px;
  background: #fff;
  text-align: center;
}
</style>
